import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
	type ProjectType,
} from '@jira/platform__project-types/src/project-types.tsx';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const GIN_SEARCH_URL = '/issues/';

export const generateNinBasePath = (
	projectKey: ProjectKey,
	projectType: ProjectType,
	isSimplifiedProject: boolean,
): string => {
	const getMainPath = (projectPath: string, simplified = true) =>
		`/jira/${projectPath}${!simplified ? '/c' : ''}/projects/${projectKey}/${fg('jira_list_nin_merge') ? 'list' : 'issues'}`;

	switch (projectType) {
		case CORE_PROJECT:
			return getMainPath('core');
		case SERVICE_DESK_PROJECT:
			return getMainPath('servicedesk');
		case SOFTWARE_PROJECT:
			return getMainPath('software', isSimplifiedProject);
		default:
			return GIN_SEARCH_URL; // Fall back to GIN
	}
};
